/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<variant-picker>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('variant-picker');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
(function() {
    'use strict';
    console.log('%c===== CUSTOM.JS LOADED =====', 'background: #222; color: #bada55; font-size: 16px; padding: 10px;');
    console.log('Timestamp:', new Date().toISOString());
    console.log('Current URL:', window.location.href);
})();

console.log('testing console 1');

// ----------------------------------------------------------------------------------------------------
// UTILITY FUNCTIONS
// ----------------------------------------------------------------------------------------------------

function getUrlVars() {
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

function getFirstAvailableVariantId(product) {
  if (!product.variants || product.variants.length === 0) {
    return null;
  }
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      return variant.id;
    }
  }
  return null;
}

/**
 * Parses the JSON content from the hidden variant metafields container.
 * Returns an empty array if the element is missing or content is invalid.
 */
function getVariantsMetafields() {
  var el = document.getElementById('hidden-variant-metafields-container');
  if (!el || !el.innerHTML.trim()) return [];
  try {
    return JSON.parse(el.innerHTML);
  } catch (e) {
    console.warn('Failed to parse variant metafields:', e);
    return [];
  }
}

/**
 * Fetches the current cart item count from the <cart-count> custom element.
 */
function getCartCount() {
  var cartCountEl = document.querySelector('cart-count');
  return cartCountEl ? parseInt(cartCountEl.textContent, 10) || 0 : 0;
}

/**
 * Looks up the longer_lead metafield value for a given variant ID.
 * Returns null if no matching metafield is found.
 */
function getLongerLead(variantsMetafields, variantId) {
  var longer_lead = null;
  variantsMetafields.forEach(function(variantMetafield) {
    if (variantMetafield.variant_id == variantId) {
      longer_lead = variantMetafield.metafield_value;
    }
  });
  return longer_lead;
}

/**
 * Activates a single stock message div by ID, hiding all others.
 * Optionally adds/removes the 'available' class on .product__info.
 */
function showStockMessage(id, isAvailable) {
  document.querySelectorAll('div.stock-message').forEach(function(el) {
    el.classList.remove('active');
  });
  var target = document.getElementById(id);
  if (target) target.classList.add('active');

  var productInfo = document.querySelector('div.product__info');
  if (productInfo) {
    if (isAvailable) {
      productInfo.classList.add('available');
    } else {
      productInfo.classList.remove('available');
    }
  }
}

/**
 * Shows or hides the Shopify payment button based on cart state.
 * Payment button is hidden when the cart already has items.
 */
function updatePaymentButton(cartCount) {
  // Hide the dynamic checkout / "Buy with Shop" button when the cart already has
  // items OR when the selected variant is sold out. #AddToCart[disabled] reflects
  // the current variant's availability (server-rendered, re-rendered on change),
  // so this keeps the payment button hidden on sold-out variants. ClickUp 86baexte7.
  var soldOut = !!document.querySelector('#AddToCart[disabled]');
  var hide = cartCount > 0 || soldOut;
  document.querySelectorAll('div[data-shopify="payment-button"]').forEach(function(paymentBtn) {
    paymentBtn.style.display = hide ? 'none' : '';
  });
}

/**
 * Core logic: given a variant object and metafields, updates the
 * stock message and payment button accordingly.
 */
function updateStockUI(variant, variantsMetafields, cartCount) {
  var variantId = variant.id;
  var longer_lead = getLongerLead(variantsMetafields, variantId);
  var inventory = variant.inventory_quantity;
  var policy = variant.inventory_policy;

  if (inventory > 0) {
    showStockMessage('inStockHasInv', true);
    updatePaymentButton(cartCount);
  } else if (inventory <= 0 && policy === 'continue' && longer_lead === 'true') {
    showStockMessage('longerLead', true);
    updatePaymentButton(cartCount);
  } else if (inventory <= 0 && policy === 'continue') {
    showStockMessage('inStockMsg', true);
    updatePaymentButton(cartCount);
  } else {
    showStockMessage('outOfStockMsg', false);
    var paymentBtn = document.querySelector('div[data-shopify="payment-button"]');
    if (paymentBtn) paymentBtn.style.display = 'none';
  }
}

// ----------------------------------------------------------------------------------------------------
// DOCUMENT READY
// ----------------------------------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
  var variantsMetafields = getVariantsMetafields();
  var pathname = window.location.pathname;
  // var sanitizedPathname = pathname.slice(1);
  // var variantId = getUrlVars()['variant'];
  var cartCount = getCartCount();

  // Accordions on "Make It Yours"
  var accordionLinks = document.querySelectorAll('#accordion li > a');
  accordionLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      document.querySelectorAll('#accordion .accordion').forEach(function(acc) {
        acc.classList.remove('focus');
      });
      var next = this.nextElementSibling;
      if (next && next.classList.contains('accordion')) {
        next.classList.add('focus');
      }
    });
  });
  
  if (!pathname.startsWith('/products/')) return;
  // Let variant:changed handle everything — just read the initial 
  // variant from the script tag the theme already outputs
  var variantScript = document.querySelector('script[data-variant]');
  if (variantScript) {
    try {
      var initialVariant = JSON.parse(variantScript.textContent);
      if (initialVariant && initialVariant.id) {
        updateStockUI(initialVariant, variantsMetafields, cartCount);
      }
    } catch(e) {}
  }

  
  // Fetch product JSON and set initial stock state
  /* fetch(window.Shopify.routes.root + sanitizedPathname + '.js')
    .then(function(response) { return response.json(); })
    .then(function(product) {
      // For Fine Jewelry, click the first option in each combo-box
      if (product.type === 'Fine Jewelry') {
        var optionLists = document.querySelectorAll('div.product-form product-variants combo-box div.combo-box__option-list');
        optionLists.forEach(function(list) {
          var firstOption = list.querySelector('button');
          if (firstOption) firstOption.click();
        });
      }

      console.log(product);

      // var productVariantElement = document.querySelector('product-variants');
      var productVariantElement = document.querySelector('variant-picker');

      if (product && variantId) {
        // --- URL contains a variant param ---
        var variants = product.variants;
        console.log(variants);

        variants.forEach(function(ele) {
          if (ele.id === parseInt(variantId)) {
            if (productVariantElement) productVariantElement.selectVariant(parseInt(variantId));
            updateStockUI(ele, variantsMetafields, cartCount);
          }
        });

      } else if (product && !variantId) {
        // --- No variant param in URL ---
        if (product.variants.length > 1 && product.type !== 'Sold Out') {
          var availableVariant = getFirstAvailableVariantId(product);
          if (productVariantElement && availableVariant) {
            productVariantElement.selectVariant(availableVariant);
          }

          product.variants.forEach(function(ele) {
            if (ele.id === availableVariant) {
              updateStockUI(ele, variantsMetafields, cartCount);
            }
          });

        } else if (product.type === 'Sold Out') {
          showStockMessage('outOfStockMsg', false);

        } else if (product.variants.length === 1) {
          updateStockUI(product.variants[0], variantsMetafields, cartCount);
        }
      }
    })
    .catch(function(err) {
      console.error('Failed to fetch product JSON:', err);
    }); */

  // Hide payment button on page load if cart already has items
  updatePaymentButton(cartCount);
});

// ----------------------------------------------------------------------------------------------------
// VARIANT CHANGED EVENT
// ----------------------------------------------------------------------------------------------------

document.addEventListener('variant:changed', function(event) {
  var variantsMetafields = getVariantsMetafields();
  var cartCount = getCartCount();
  var variant = event.detail.variant;

  if (variant) {
    console.log('longer_lead:', getLongerLead(variantsMetafields, variant.id));
    updateStockUI(variant, variantsMetafields, cartCount);
  } else {
    // Fallback: if no variant detail, re-fetch product to check type
    var sanitizedPathname = window.location.pathname.slice(1);
    fetch(window.Shopify.routes.root + sanitizedPathname + '.js')
      .then(function(response) { return response.json(); })
      .then(function(product) {
        if (product && product.type === 'Fine Jewelry') {
          showStockMessage('inStockMsg', true);
        }
      })
      .catch(function(err) {
        console.error('Failed to fetch product JSON in variant:changed fallback:', err);
      });
  }

  updatePaymentButton(cartCount);
});

// ----------------------------------------------------------------------------------------------------
// CART UPDATED EVENT
// ----------------------------------------------------------------------------------------------------

document.addEventListener('cart:updated', function(event) {
  var cart = event.detail.cart;
  if (cart.item_count > 0) {
    var paymentBtn = document.querySelector('div[data-shopify="payment-button"]');
    if (paymentBtn) paymentBtn.style.display = 'none';
  }
});

// ----------------------------------------------------------------------------------------------------
// FORM UTILITIES (highlight, validation, etc.)
// ----------------------------------------------------------------------------------------------------

addEvent(window, 'load', initForm);

var highlight_array = new Array();

function initForm() {
  initializeFocus();
  var activeForm = document.getElementsByTagName('form')[0];
  if (activeForm) addEvent(activeForm, 'submit', disableSubmitButton);
  ifInstructs();
  showRangeCounters();
}

function disableSubmitButton() {
  var saveForm = document.getElementById('saveForm');
  if (saveForm) saveForm.disabled = true;
}

function initializeFocus() {
  var fields = getElementsByClassName(document, "*", "field");

  for (var i = 0; i < fields.length; i++) {
    if (fields[i].type === 'radio' || fields[i].type === 'checkbox') {
      fields[i].onclick = function() { highlight(this, 4); };
      fields[i].onfocus = function() { highlight(this, 4); };
    } else if (fields[i].className.match('addr') || fields[i].className.match('other')) {
      fields[i].onfocus = function() { highlight(this, 3); };
    } else {
      fields[i].onfocus = function() { highlight(this, 2); };
    }
  }
}

function highlight(el, depth) {
  var fieldContainer = el;
  for (var i = 0; i < depth; i++) {
    fieldContainer = fieldContainer.parentNode;
    if (!fieldContainer) return;
  }

  addClassName(fieldContainer, 'focused', true);
  var focusedFields = getElementsByClassName(document, "*", "focused");

  for (var i = 0; i < focusedFields.length; i++) {
    if (focusedFields[i] !== fieldContainer) {
      removeClassName(focusedFields[i], 'focused');
    }
  }
}

function ifInstructs() {
  var container = document.getElementById('public');
  if (container) {
    removeClassName(container, 'noI');
    var instructs = getElementsByClassName(document, "*", "instruct");
    if (instructs.length === 0) {
      addClassName(container, 'noI', true);
    }
    if (container.offsetWidth <= 450) {
      addClassName(container, 'altInstruct', true);
    }
  }
}

function showRangeCounters() {
  var counters = getElementsByClassName(document, "em", "currently");
  for (var i = 0; i < counters.length; i++) {
    counters[i].style.display = 'inline';
  }
}

function validateRange(ColumnId, RangeType) {
  var msg = document.getElementById('rangeUsedMsg' + ColumnId);
  if (msg) {
    var field = document.getElementById('Field' + ColumnId);
    switch (RangeType) {
      case 'character':
        msg.innerHTML = field.value.length;
        break;
      case 'word':
        var val = field.value.replace(/\n/g, " ");
        var words = val.split(" ");
        var used = 0;
        for (var i = 0; i < words.length; i++) {
          if (words[i].replace(/\s+$/, "") !== "") used++;
        }
        msg.innerHTML = used;
        break;
      case 'digit':
        msg.innerHTML = field.value.length;
        break;
    }
  }
}

/*--------------------------------------------------------------------------*/

//http://www.robertnyman.com/2005/11/07/the-ultimate-getelementsbyclassname/
function getElementsByClassName(oElm, strTagName, strClassName) {
  var arrElements = (strTagName == "*" && oElm.all) ? oElm.all : oElm.getElementsByTagName(strTagName);
  var arrReturnElements = new Array();
  strClassName = strClassName.replace(/\-/g, "\\-");
  var oRegExp = new RegExp("(^|\\s)" + strClassName + "(\\s|$)");
  var oElement;
  for (var i = 0; i < arrElements.length; i++) {
    oElement = arrElements[i];
    if (oRegExp.test(oElement.className)) {
      arrReturnElements.push(oElement);
    }
  }
  return (arrReturnElements);
}

//http://www.bigbold.com/snippets/posts/show/2630
function addClassName(objElement, strClass, blnMayAlreadyExist) {
  if (objElement.className) {
    var arrList = objElement.className.split(' ');
    if (blnMayAlreadyExist) {
      var strClassUpper = strClass.toUpperCase();
      for (var i = 0; i < arrList.length; i++) {
        if (arrList[i].toUpperCase() == strClassUpper) {
          arrList.splice(i, 1);
          i--;
        }
      }
    }
    arrList[arrList.length] = strClass;
    objElement.className = arrList.join(' ');
  } else {
    objElement.className = strClass;
  }
}

//http://www.bigbold.com/snippets/posts/show/2630
function removeClassName(objElement, strClass) {
  if (objElement.className) {
    var arrList = objElement.className.split(' ');
    var strClassUpper = strClass.toUpperCase();
    for (var i = 0; i < arrList.length; i++) {
      if (arrList[i].toUpperCase() == strClassUpper) {
        arrList.splice(i, 1);
        i--;
      }
    }
    objElement.className = arrList.join(' ');
  }
}

//http://ejohn.org/projects/flexible-javascript-events/
function addEvent(obj, type, fn) {
  if (obj.attachEvent) {
    obj["e" + type + fn] = fn;
    obj[type + fn] = function() { obj["e" + type + fn](window.event); };
    obj.attachEvent("on" + type, obj[type + fn]);
  } else {
    obj.addEventListener(type, fn, false);
  }
}